import { AppFullRoutes } from '../enum/appRoutes';

export type DashboardRole =
  | 'hmo'
  | 'superadmin'
  | 'insuree'
  | 'provider'
  | 'nhia'
  | 'payer'
  | 'employer';

export function normalizeDashboardRole(
  value: unknown
): DashboardRole | null {
  if (typeof value !== 'string') {
    return null;
  }

  const role = value.trim().toLowerCase();

  switch (role) {
    case 'hmo':
    case 'superadmin':
    case 'insuree':
    case 'provider':
    case 'nhia':
    case 'payer':
    case 'employer':
      return role;

    default:
      return null;
  }
}

export function getDashboardRoute(
  role: DashboardRole
): string {
  switch (role) {
    case 'hmo':
      return AppFullRoutes.FULL_HMO_DASHBOARD;

    case 'superadmin':
      return AppFullRoutes.FULL_SUPER_ADMIN_DASHBOARD;

    case 'insuree':
      return AppFullRoutes.FULL_INSUREE_DASHBOARD;

    case 'provider':
      return AppFullRoutes.FULL_PROVIDER_DASHBOARD;

    case 'nhia':
      return AppFullRoutes.FULL_NHIA_DASHBOARD;

    case 'payer':
    case 'employer':
      return AppFullRoutes.FULL_EMPLOYER_DASHBOARD;
  }
}